import API from "../constants/api.constant";
import {responseErrorHandling} from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

// Function to get inbox for user
export const getInbox = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  type?: string;
  status?: string;
}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.type && params.type !== 'all') queryParams.append('type', params.type);
    if (params?.status && params.status !== 'all') queryParams.append('status', params.status);
    const url = `${API.GET_INBOX}?${queryParams.toString()}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error)
  }
};

// Function to get unread count for user
export const getUnreadCount = async () => {
  try {
    const response = await axiosInstance.get(API.GET_UNREAD_COUNT);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error)
  }
};

// Function to mark notification as read
export const markAsRead = async (id: string) => {
  try {
    const response = await axiosInstance.patch(API.MARK_AS_READ + `/${id}/read`);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error)
  }
};
